<div class="login-methods" *ngIf="loginMethods && loginMethods.length > 0">
  <div class="login-or-divider" [ngClass]="{'new-ui-divider': useNewLoginPageUI}" *ngIf="isAllowTeamNoteLogin && !useNewLoginPageUI">
    - {{'GENERAL.OR' | translate}} -
  </div>
  <div class="login-body-row method-wrapper" *ngFor="let method of loginMethods">
    <button class="btn btn-info btn-block" (click)="onLoginMethodClick(method)">
      {{getButtonDisplayText(method)}}
      <div class="staff-only-text" *ngIf="ssoExtraWordings.length">
        {{ssoExtraWordings}}
      </div>
    </button>
  </div>
</div>